import { useState } from "react";
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Stack } from "@mui/material";

function ContactoForm({ store, leadId, onClose }) {
  const unavailable = !store.leads.some(l => l.id === leadId);
  const [hasNota, setHasNota] = useState(false);
  const submit = e => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const nota = String(data.get("nota") || "").trim();
    if (!nota || unavailable) return;
    store.agregarContacto(leadId, { tipo: data.get("tipo"), nota });
    onClose();
  };
  return <form onSubmit={submit}>
    <DialogContent>
      {unavailable && <Alert severity="warning">Este cliente ya no está disponible. Puedes copiar tu nota antes de cerrar.</Alert>}
      <Stack spacing={2} mt={1}>
        <TextField name="tipo" label="Tipo de contacto" defaultValue="whatsapp" select fullWidth>
          <MenuItem value="whatsapp">WhatsApp</MenuItem><MenuItem value="llamada">Llamada</MenuItem>
          <MenuItem value="presencial">Presencial</MenuItem><MenuItem value="visita">Visita</MenuItem>
          <MenuItem value="email">Email</MenuItem><MenuItem value="otro">Otro</MenuItem>
        </TextField>
        <TextField name="nota" label="Nota / Resultado" defaultValue="" onChange={e => setHasNota(Boolean(e.target.value.trim()))}
          multiline rows={3} fullWidth autoFocus placeholder="¿Qué pasó en el contacto?" />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
      <Button variant="contained" type="submit" disabled={!hasNota || unavailable}>Registrar</Button>
    </DialogActions>
  </form>;
}
export default function ContactoDialog({ open, onClose, store, leadId }) {
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle fontWeight={700}>Registrar contacto</DialogTitle>
    {open && <ContactoForm key={leadId} store={store} leadId={leadId} onClose={onClose} />}
  </Dialog>;
}
